// extracted by mini-css-extract-plugin
export default {"titleContainer":"map_titleContainer__1WOPR","container":"map_container__hA6eV"};